import { defineComponent as _defineComponent } from 'vue'
import RmpSpinnerLoader from "@rmp/core/components/loaders/common/RmpSpinnerLoader.vue";
import { useAppStore } from "@rmp/core/stores/appStore";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const appStore = useAppStore();
const { middlewareExecuted } = storeToRefs(appStore);

return { __sfc: true,appStore, middlewareExecuted, RmpSpinnerLoader }
}

})